<div class="container">
    <div class="text-center mt-4">
        <h3>Frequently Asked Questions</h3>
        <p>Find the most asked question & their answer right here.</p>
    </div>
    <div class="mt-4 mx-auto" style="max-width: 800px;">
        <form>
            <div class="input-group mb-3">
                <input type="text" class="form-control form-control-lg" placeholder="Search your question here...">
                <button class="btn btn-primary">Search</button>
            </div>
        </form>
    </div>
    <div class="mt-5">
        <div class="row">
            <div class="col-md-3" *ngFor="let item of category">
                <div class="card card-clickable" 
                    [ngClass]="{'active': item.title === selectedCategory}" 
                    (click)="selectCategory(item.title)"
                >
                    <div class="card-body text-center">
                        <div 
                            class="d-inline-block rounded-circle" 
                            [ngStyle]="{'background-color': hexToRGB(item.color, 0.1)}"
                        >
                            <i 
                                class="h1 mb-0 p-3" 
                                [ngClass]="item.icon"
                                [ngStyle]="{'color': item.color}"
                            ></i>
                        </div>
                        <h5 class="mt-3 mb-0">{{item.title}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-4">
        <div class="card">
            <div class="card-body">
                <accordion [isAnimated]="true">
                    <accordion-group *ngFor="let item of faqList[selectedCategory]" [(isOpen)]="item.open">
                        <button class="btn btn-link btn-block text-start" accordion-heading>
                            <i 
                                class="feather icon-chevron-right text-primary d-inline-block" 
                                [ngStyle]="{'transform': item.open? 'rotate(90deg)' : 'rotate(0deg)'}"
                            >
                            </i>
                            <span class="ms-2">{{item.title}}</span>
                        </button>
                        <p class="mb-0">
                            {{item.desc}}
                        </p>
                    </accordion-group>
                  </accordion>
            </div>
        </div>
    </div>
</div>
